module.exports = __webpack_public_path__ + "ncafe.png?3698c023dd5295e7fa88fdc054704a64";


//////////////////
// WEBPACK FOOTER
// ./images/ncafe.png
// module id = 271
// module chunks = 0